<script>
	import { resolve } from '$app/paths';
	import { localizeHref } from '@/paraglide/runtime';
</script>

<svelte:head>
	<title>Términos Tarjeta Regalo | Zarpar</title>
	<meta
		name="description"
		content="Condiciones de uso de las tarjetas regalo de Zarpar, vigencia, uso, cancelaciones y relación con las condiciones generales."
	/>
</svelte:head>

<div class="mx-auto max-w-3xl px-2 py-14 md:px-0">
	<div class="relative mx-auto max-w-150 pb-16 text-center">
		<h1 class="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
			Términos y Condiciones de la Tarjeta Regalo
		</h1>
		<p class="mt-4 text-base leading-7 text-slate-600">Última actualización 05/12/2025</p>
	</div>

	<div
		class="prose prose-sm prose-slate prose-a:font-semibold prose-a:text-sky-500 hover:prose-a:text-sky-600 mx-auto max-w-160"
	>
		<p>
			Las presentes condiciones regulan la compra y uso de las tarjetas regalo emitidas por
			<strong>PLATAFORMA NÁUTICA DIGITAL, S.L.</strong> (en adelante, “Zarpar”). Para cualquier
			reserva realizada con una tarjeta regalo aplican, además, los
			<a href={resolve(localizeHref('/terminos-y-condiciones'))}>Términos y Condiciones Generales</a
			> de Zarpar.
		</p>

		<h2 class="mb-3 text-lg font-semibold">1. Naturaleza y titularidad</h2>
		<ul class="list-disc space-y-2 pl-5">
			<li>
				La tarjeta regalo es un documento al portador que incorpora un código promocional canjeable
				en
				<a href={resolve(localizeHref('/'))}>zarpar.eu</a>; no es un instrumento financiero ni
				genera intereses.
			</li>
			<li>
				El emisor es PLATAFORMA NÁUTICA DIGITAL, S.L., CIF B67961577, con domicilio en España.
			</li>
			<li>
				La posesión del código acredita el derecho de uso. Custódialo; no nos hacemos responsables
				de pérdidas o usos no autorizados.
			</li>
		</ul>

		<h2 class="mb-3 text-lg font-semibold">2. Vigencia y ámbito de uso</h2>
		<ul class="list-disc space-y-2 pl-5">
			<li>Validez: seis (6) meses desde la fecha de compra indicada en el correo de entrega.</li>
			<li>
				Ámbito: canjeable en reservas de alquiler o experiencias ofrecidas en Zarpar, sujeto a
				disponibilidad.
			</li>
			<li>
				Moneda: importe en euros; no es canjeable por dinero en efectivo ni transferible a otras
				plataformas.
			</li>
		</ul>

		<h2 class="mb-3 text-lg font-semibold">3. Canje y condiciones económicas</h2>
		<ul class="list-disc space-y-2 pl-5">
			<li>
				El canje se realiza introduciendo el código en el proceso de reserva antes del pago, en la
				página del procesador de pagos (Stripe).
			</li>
			<li>
				Si el precio de la reserva supera el saldo de la tarjeta, el titular abonará la diferencia
				por los medios de pago disponibles.
			</li>
			<li>
				Si el precio es inferior al saldo de la tarjeta, el remanente se pierde y no es
				reembolsable.
			</li>
			<li>
				No se admiten reembolsos ni cambios por saldo en metálico, salvo los derechos imperativos
				del consumidor que resulten aplicables.
			</li>
		</ul>

		<h2 class="mb-3 text-lg font-semibold">4. Cancelaciones y modificaciones</h2>
		<ul class="list-disc space-y-2 pl-5">
			<li>
				Las cancelaciones o cambios de reservas efectuadas con tarjeta regalo se rigen por los
				<a href="/terminos-y-condiciones">Términos y Condiciones Generales</a> y las políticas específicas
				de cada servicio.
			</li>
			<li>
				Si Zarpar cancela una reserva por causas imputables a la plataforma o por fuerza mayor, se
				repondrá el saldo asociado a la tarjeta o se emitirá una nueva con la vigencia que reste.
			</li>
			<li>
				No se generarán reembolsos en metálico en caso de no utilización, caducidad o desistimiento
				tras el canje, salvo lo previsto por la normativa aplicable.
			</li>
		</ul>

		<h2 class="mb-3 text-lg font-semibold">5. Seguridad, fraude y uso indebido</h2>
		<ul class="list-disc space-y-2 pl-5">
			<li>
				Zarpar puede bloquear o anular tarjetas en caso de fraude, robo, uso ilícito o error
				manifiesto.
			</li>
			<li>
				La tarjeta no puede revenderse ni utilizarse con fines promocionales sin autorización
				escrita.
			</li>
			<li>
				En caso de pérdida o sospecha de uso no autorizado, contacta con <a
					href="mailto:info@zarpar.eu">info@zarpar.eu</a
				>; los reemplazos se evaluarán caso a caso.
			</li>
		</ul>

		<h2 class="mb-3 text-lg font-semibold">6. Protección de datos</h2>
		<p>
			Los datos personales facilitados para la emisión y uso de la tarjeta se tratan según la
			Política de Privacidad de Zarpar y, en lo no previsto, conforme a los
			<a href="/terminos-y-condiciones">Términos y Condiciones Generales</a>.
		</p>

		<h2 class="mb-3 text-lg font-semibold">7. Ley aplicable y resolución de disputas</h2>
		<ul class="list-disc space-y-2 pl-5">
			<li>
				Estas condiciones se rigen por la legislación española y la normativa de defensa de
				consumidores y usuarios.
			</li>
			<li>
				Para incidencias, contáctanos en <a href="mailto:info@zarpar.eu">info@zarpar.eu</a>.
			</li>
		</ul>
	</div>
</div>
